module.exports = __webpack_public_path__ + "img/logo-red-short.509f57e0.png";